import { array } from "prop-types";
import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { COMMON, COMPANY } from "../config/apiEndPoint";
import { GET, POST, PUT } from "config/api.config";

export const getCompanyList = async (data = array()) => {
  try {
    const url = data?._Id
      ? `${COMPANY.GET_COMPANY_LIST}/${data?._Id}`
      : `${COMPANY.GET_COMPANY_LIST}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const addCompany = async (data = array()) => {
  try {
    const response = await POST(COMPANY.ADD_COMPANY, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const updateCompany = async (id, data = array()) => {
  try {
    const url = `${COMPANY.ADD_COMPANY}/${id}`;
    const response = await PUT(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getCompanyDataById = async (data = array()) => {
  try {
    const url = data?.Id
      ? `${COMPANY.GET_COMPANY_LIST}/${data?.Id}`
      : `${COMPANY.GET_COMPANY_LIST}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchCompanyTableAndFilterSchema = async (data = array()) => {
  try {
    const url = data?._Id
      ? `${COMPANY.GET_COMPANY_SCHEMA}/${data?._Id}`
      : `${COMPANY.GET_COMPANY_SCHEMA}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitCompanyFilterData = async (data = array()) => {
  try {
    const response = await POST(COMPANY.SUBMIT_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `common/company-autocomplete` — body `{ nameContains }`. */
export const submitCompanyAutocomplete = async (data = {}) => {
  try {
    const response = await POST(COMMON.COMPANY_AUTOCOMPLETE, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
